import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

import { dividerColor } from '@savvy/deprecated-shared/theme';

/**
 * @deprecated MUI is deprecated. Use the @savvy/savvy-kit library instead.
 */
const AdvisorDashboardCard = styled(Card)({
  border: `1px solid ${dividerColor}`,
  boxShadow: 'none',
  borderRadius: '8px',
  '.dark &': {
    backgroundColor: 'var(--card)',
  },
});

export default AdvisorDashboardCard;
